<template>
  <div class="register absolute">
    <div class="shading">
      <div class="pictrue acea-row row-center-wrapper">
        <img src="@assets/images/minilogo.png" />
      </div>
    </div>
    <div class="whiteBg">
      <div class="title">Retrieve password</div>
      <div class="list">
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-phone_"></use>
            </svg>
            <span class="chooseArea" @click="chooseArea()">
              <slot name="country_tel">+{{ area }}</slot>
              <span
              ><svg
                      t="1566640213388"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="2787"
                      width="18"
                      height="18"
              >
                  <path
                          d="M512 721.5c-4.6 0-9.2-1.8-12.7-5.3l-383.1-383c-7-7-7-18.4 0-25.5s18.4-7 25.5 0L512 678.1l370.3-370.3c7-7 18.4-7 25.5 0 7 7 7 18.4 0 25.5l-383.1 383c-3.5 3.5-8.1 5.2-12.7 5.2z"
                          p-id="2788"
                  ></path></svg
              ></span>
            </span>
            <input type="text" placeholder="Enter your phone number" v-model="account" />
          </div>
        </div>
        <div class="item">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_1"></use>
            </svg>
            <input
              type="text"
              placeholder="Please fill in verification code"
              class="codeIput"
              v-model="captcha"
            />
            <button
              class="code"
              :disabled="disabled"
              :class="disabled === true ? 'on' : ''"
              @click="code"
            >
              {{ text }}
            </button>
          </div>
        </div>
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg>
            <input
              type="password"
              placeholder="Your new password"
              v-model="password"
            />
          </div>
        </div>
      </div>
      <div class="logon" @click="registerReset">Confirm</div>
      <div class="tip">
        <span @click="$router.push({ name: 'Login' })" class="font-color-blue"
          >Login</span
        >
      </div>
    </div>
    <div class="bottom"></div>
  </div>
</template>

<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import { registerVerify, registerReset } from "@api/user";
import { validatorDefaultCatch } from "@utils/dialog";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";

export default {
  name: "RetrievePassword",
  data: function() {
    return {
      account: "",
      password: "",
      captcha: "",
      area: "63",

    };
  },
  watch: {
    $route() {
      // this.area = this.$route.params.tel?this.$route.params.tel:this.localStorage.get("default_country_code");
      this.area = this.localStorage.get("Area")
              ? this.localStorage.get("Area")
              : this.localStorage.get("default_country_code");
      // console.log('this.area',this.area)
    }
  },
  mixins: [sendVerifyCode],
  methods: {
    chooseArea: function() {
      this.$router.push({ path: "/selectCode" });
    },
    async registerReset() {
      var that = this;
      const {  captcha, password } = that;
      if(!this.account){
        return that.$dialog.error('Please enter your phone number');
      }
      try {
        await that
          .$validator({
            captcha: [
              required(required.message("code")),
              alpha_num(alpha_num.message("code"))
            ],
            password: [
              required(required.message("password")),
              attrs.range([6, 16], attrs.range.message("password")),
              alpha_num(alpha_num.message("password"))
            ]
          })
          .validate({  captcha, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      registerReset({
        account:that.area + that.account,
        captcha: that.captcha,
        password: that.password
      })
        .then(res => {
          that.$dialog.success(res.msg).then(() => {
            that.$router.push({ name: "Login" });
          });
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    async code() {
      var that = this;
      if(!this.account){
       return that.$dialog.error('Please enter your phone number');
      }
      registerVerify({ phone:that.area + that.account })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    }
  }
};
</script>
